<template>
  <label class="checkbox">
    <input
      class="checkbox__input"
      type="checkbox"
      :name="name"
      v-bind="checked"
      @change="handleChange">
    <i class="checkbox__icon"></i>
    <div class="checkbox__label">
      <slot></slot>
    </div>
  </label>
</template>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleChange(event) {
      this.$emit('input', event.currentTarget.checked);
    },
  },
};
</script>

<style lang="scss">
.checkbox {
  &__input {
    position: absolute;
    left: -20000px;
    margin-right: 0.71875rem;
  }

  &__icon {
    float: left;
    width: 20px;
    height: 20px;
    border: 1px solid #979797;
    border-radius: 0.25rem;
    margin-right: 1rem;
    box-sizing: border-box;
  }

  &__input:checked + &__icon {
    background: none;
    border: none;

    &::before {
      content: '';
      display: inline-block;
      width: 20px;
      height: 20px;
      background-image: url('~@/assets/images/icons/checkbox.png');
      box-sizing: border-box;
    }
  }
}
</style>
